import { DataLayerModel } from './data-layer.model';

export class PageTimeSpentDataLayerModel extends DataLayerModel {
	public static readonly EVENT_NAME: string = "PAGE_TIME_SPENT";
	public timeSpentInSeconds: number;
	public constructor(timeSpentInSeconds: number) {
		super(PageTimeSpentDataLayerModel.EVENT_NAME);
		this.timeSpentInSeconds = timeSpentInSeconds;
	}
}